import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TokenCache } from '../../security/token-cache';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
  selector: 'app-meter-true-up-detail',
  templateUrl: './meter-true-up-detail.component.html',
  styleUrls: ['./meter-true-up-detail.component.css']
})
export class MeterTrueUpDetailComponent implements OnInit, OnDestroy  {

  showRunTab: boolean = false;
  selectedIndex: number;
  private routerSubscription: Subscription;

  constructor(
    public snackBar: MatSnackBar,
    private tokenCache: TokenCache,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.showRunTab = this.tokenCache.checkForCPMAdmin();
    this.syncFromUrl(this.router.url);
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.syncFromUrl(event.urlAfterRedirects);
      });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  public onTabChange(event: MatTabChangeEvent): void {
    this.navigateToTab(event.index);
  }

  private getTabs(): string[] {
    const tabs = [];
    if (this.showRunTab) {
      tabs.push('runs');
    }
    tabs.push('system');
    tabs.push('meters');
    tabs.push('spaces');
    tabs.push('closures');
    return tabs;
  }

  private navigateToTab(index: number): void {
    const tabKey = this.getTabs()[index];
    if (!tabKey) {
      return;
    }

    const targetUrl = `/trueup/${tabKey}`;
    if (this.router.url !== targetUrl) {
      this.router.navigateByUrl(targetUrl);
    }
  }

  private syncFromUrl(url: string): void {
    const tabs = this.getTabs();
    const tabMatch = tabs.find((tab) => url.includes(`/trueup/${tab}`));
    const index = tabMatch ? tabs.indexOf(tabMatch) : 0;
    const normalizedKey = tabs[index];
    this.selectedIndex = index;

    const targetUrl = `/trueup/${normalizedKey}`;
    if (!url.includes('/trueup/') || !url.includes(targetUrl)) {
      this.router.navigateByUrl(targetUrl, { replaceUrl: true });
    }
  }
}

